import React, { useState } from "react";
import { setReminderOndemand } from "../../../services/medium";
import { toast } from "react-toastify";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function UpcomingPastEventPopup({ onYesClick, onNoClick }) {
  const { t } = useTranslation("mediumPracticePopups");

  return (
    <div className="confirm-delete-wrapper register-medium">
      <div id="UpcomingPastEventPopup" class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                {/* <img src="images/Union-icon.png" alt="Union-icon" /> */}
                <h3>{t("upcomingPast.title")}</h3>
              </div>
              <p><b>{t("upcomingPast.question")}</b></p>
              <div className="confirm-btn-box">

                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={onYesClick}
                >
                  {t("upcomingPast.upcoming")}
                </div>
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={onNoClick}
                  data-dismiss="modal"
                >
                  {t("upcomingPast.past")}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
